var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"mr-2",attrs:{"color":"Danger","type":"border","icon-pack":"feather","icon":"icon-trash"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }